export class DraftProductModel {
  /**
   * item number of the product
   * @example '29.99866'
   */
  public name: string;
  /**
   * Name of the product with version number, but without color
   * @example 'Cloudflow 3'
   */
  public productGroupName: string;
  /**
   * Full product name description with size color and size
   * @example 'Cloudstratus 1 Navy | Dust W 8.5'
   */
  public description: string;
  /**
   * also called product barcode or EAN code
   */
  public productId: string;

  public lineId: string;
  public quantity: number;
  public unitPrice: number;
  public totalPrice?: number;
  public lineItemNumber: number;
  public unitDiscount: number;
}
